/* eslint-disable max-len */
/* eslint-disable complexity */
/* eslint-disable no-loop-func */
import React from 'react';

const RateInventory = (props) => {
  // ...existing code...
  const { commonData, others, otaCategoryRateplan, userId, dateList, rateInventory } = props;
    const dateSectionPopulate = (categoryId, rateplanId) => {
    return Object.keys(dateList).map(date => {
      let inventoryToolTip = '';
      if (
        typeof rateInventory[categoryId] !== 'undefined' &&
        typeof rateInventory[categoryId]['rates'][rateplanId] !== 'undefined' &&
        typeof rateInventory[categoryId]['rates'][rateplanId][userId] !== 'undefined' &&
        typeof rateInventory[categoryId]['rates'][rateplanId][userId]['inventory'][date] !== 'undefined'
      ) {
        inventoryToolTip =
          'Min Los : ' +
          rateInventory[categoryId]['rates'][rateplanId][userId]['inventory'][date]['minlos'];
        if (
          rateInventory[categoryId]['rates'][rateplanId][userId]['inventory'][date]['maxlos'] > 0
        ) {
          inventoryToolTip +=
            '\nMax Los : ' +
            rateInventory[categoryId]['rates'][rateplanId][userId]['inventory'][date]['maxlos'];
        } else {
          inventoryToolTip += '\nMax Los : Unlimited';
        }
      } else {
        inventoryToolTip = 'Min Los : 0\nMax Los : 0';
      }
      return (
        <React.Fragment key={`dateSectionPopulate-${date}`}>
          <div className="tabcel align_middle pad_top_bot5 border_b_1 border_r_1 border_color_1 tc rv_width_2 rv_height_2">
            <div className="cursor_p inline offset_wrap" title={inventoryToolTip}>
              <div className="offset_btn inline border_all_1 border_color_3 full-round align_middle">
                <span className="icon_size1">
                  {' '}
                  <i className="fa fa-ellipsis-h color2_5 fnt10"></i>
                </span>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    });
  };

  const bindOccupancyRate = (userId, categoryId, rateplanId, occupancyId, occupanyRates) => {
    let dateListSection = Object.keys(dateList).map(date => (
      <div
        key={`bindOccupancyRate-${date}-${categoryId}`}
        className="tabcel align_middle pad_top_bot5 border_b_1 border_r_1 border_color_1 tc rv_width_2 rv_height_2 posrel"
        onClick={event =>
          props.selectCellEventHandler(event, {
            datekey: date,
            categoryId: categoryId,
            occupancyId: occupancyId,
            ratePlanId: rateplanId,
            userId: userId
          })
        }
      >
        {typeof occupanyRates[date] !== 'undefined' && typeof occupanyRates[date]['aop'] !== 'undefined'
          ? occupanyRates[date]['aop_and_tax']
          : ''}

        {typeof others.rateinventorySelectedSection[rateplanId] !== 'undefined' &&
        typeof others.rateinventorySelectedSection[rateplanId][userId] !== 'undefined' &&
        typeof others.rateinventorySelectedSection[rateplanId][userId][categoryId] !== 'undefined' &&
        typeof others.rateinventorySelectedSection[rateplanId][userId][categoryId][date] !== 'undefined' &&
        typeof others.rateinventorySelectedSection[rateplanId][userId][categoryId][date][occupancyId] !==
          'undefined' &&
        typeof others.rateinventorySelectedSection[rateplanId][userId][categoryId][date][occupancyId][
          'isSelected'
        ] !== 'undefined' &&
        others.rateinventorySelectedSection[rateplanId][userId][categoryId][date][occupancyId][
          'isSelected'
        ] === 1 ? (
            <i className="fa fa-check color7 fnt10 color2_8 chkshow marg_right5"></i>
          ) : (
            ''
          )}
      </div>
    ));
    return dateListSection;
  }

  const bindExtrabedRate = (userId, categoryId, rateplanId) => {
    let extrabedRates = commonData.otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates'];

    let dateListSection = Object.keys(dateList).map(date => (
      <React.Fragment key={`bindExtrabedRate-${date}`}>
        <div className="tabcel align_middle pad_top_bot5 border_b_1 border_r_1 border_color_1 tc rv_width_2 rv_height_2 posrel">
          {typeof typeof extrabedRates['kidextrabed'] !== 'undefined' &&
          typeof extrabedRates['kidextrabed'][date] !== 'undefined' &&
          typeof extrabedRates['kidextrabed'][date]['extraBed_and_tax'] !== 'undefined'
            ? extrabedRates['kidextrabed'][date]['extraBed_and_tax']
            : '0.00'}
        </div>
      </React.Fragment>
    ));
    return dateListSection;
  }

  const bindKidRate = (userId, categoryId, rateplanId) => {
    let extrabedRates = commonData.otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates'];
    let dateListSection = Object.keys(dateList).map(date => (
      <React.Fragment key={`bindKidRate-${date}`}>
        <div className="tabcel align_middle pad_top_bot5 border_b_1 border_r_1 border_color_1 tc rv_width_2 rv_height_2 posrel">
          {typeof typeof extrabedRates['kidextrabed'] !== 'undefined' &&
          typeof extrabedRates['kidextrabed'][date] !== 'undefined' &&
          typeof extrabedRates['kidextrabed'][date]['kid_and_tax'] !== 'undefined'
            ? extrabedRates['kidextrabed'][date]['kid_and_tax']
            : '0.00'}
        </div>
      </React.Fragment>
    ));
    return dateListSection;
  }

  const extaBedUIHandler = (userId, categoryId, rateplanId) => {
    let extrabedUI = Object.keys(others.extrabed).map(keys => (
      <React.Fragment key={`extaBedUIHandler-${keys}`}>
        <div className="table_row">
          <div className="tabcel align_middle pad_top_bot5 bg2_3 border_l_1 border_b_1 border_r_1 border_color_1 pad_left30 rvfixed_cell rv_width_1 rv_height_2">
            <div className="ovr">
              <div className="table_col table_fixed">
                <div className="tabcel align_middle">
                  <div className="text_end ovr">{others.extrabed[keys]}</div>
                </div>
                <div className="tabcel align_middle wdhpx30"></div>
              </div>
            </div>
          </div>
          {keys === 'extra_bed'
            ? bindExtrabedRate(userId, categoryId, rateplanId)
            : bindKidRate(userId, categoryId, rateplanId)}
        </div>
      </React.Fragment>
    ));
    return extrabedUI;
  }

  const bindOccupancySection = (userId, categoryId, rateplanId) => {
    let occupanyRates = commonData.otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates'][
      'occupancy'
    ];

    let rateSection = Object.keys(occupanyRates).map(occupancyId => (
      <React.Fragment key={`bindOccupancySection-${occupancyId}`}>
        <div className="table_row">
          <div className="tabcel align_middle pad_top_bot5 bg2_3 border_l_1 border_b_1 border_r_1 border_color_1 pad_left30 rvfixed_cell rv_width_1 rv_height_2">
            <div className="ovr">
              <div className="table_col table_fixed">
                <div className="tabcel align_middle">
                  <div className="text_end ovr">{commonData.occupancyList[occupancyId]}</div>
                </div>
                <div
                  className="tabcel align_middle wdhpx30"
                  onClick={event =>
                    props.horizontalRowSelection(event, {
                      userId: userId,
                      rateplanId: rateplanId,
                      categoryId: categoryId,
                      occupancyId: occupancyId
                    })
                  }
                >
                  {typeof others.horizontalRowChecked[categoryId] !== 'undefined' &&
                  typeof others.horizontalRowChecked[categoryId][rateplanId] !== 'undefined' &&
                  typeof others.horizontalRowChecked[categoryId][rateplanId][occupancyId] !== 'undefined' &&
                  others.horizontalRowChecked[categoryId][rateplanId][occupancyId]['is_checked'] === 1 ? (
                      <i className="fa fa-check fnt10 color7"></i>
                    ) : (
                      ''
                    )}
                </div>
              </div>
            </div>
          </div>
          {bindOccupancyRate(userId, categoryId, rateplanId, occupancyId, occupanyRates[occupancyId])}
        </div>
      </React.Fragment>
    ));
    return rateSection;
  }

  const getOtaRateplanName = (categoryId, categoryList, rateplanId) => {
    let channelMappingID = categoryId.split('_');
    let result = '';
    Object.keys(categoryList).map(key => {
      if (categoryList[key]['pms_category_id'] == channelMappingID[0]) {
        Object.keys(categoryList[key]['rateplans']).map(ratplanKey => {
          if ((categoryList[key]['rateplans'][ratplanKey]['rate_plan_id'] == rateplanId) && (categoryList[key]['rateplans'][ratplanKey]['rate_plan_mapping_id'] == channelMappingID[1])) {
            result = categoryList[key]['rateplans'][ratplanKey]['channel_rate_plan_name'];
          }
        });
      }
    });
    return result;
  }

  const ratePlanUIpaint = (categoryId, userId) => {
    let catMapArr = categoryId.split('_');
    let catId = catMapArr[0];
    let rateplanSection = '';

    if (userId > 0) {
      let otaCategoryRateplan = otaCategoryRateplan[userId];
      if (
        typeof commonData.otaData[userId]['category'][categoryId] !== 'undefined' &&
        typeof commonData.otaData[userId]['category'][categoryId]['rateplans'] !== 'undefined'
      ) {
        rateplanSection = Object.keys(commonData.otaData[userId]['category'][categoryId]['rateplans']).map(
          rateplanId => (
            <React.Fragment key={categoryId}>
              <div className="cover">
                <div className="table_seperate table_fixed">
                  <div className="table_row">
                    <div className="tabcel align_middle pad_top_bot5 bg1 border_l_1 border_b_1 border_r_1 border_color_1 rvfixed_cell rv_width_1 rv_height_2">
                      <div className="ovr">
                        <div
                          className="table_col table_fixed cursor_p"
                          onClick={event =>
                            props.expandCollapseCategorySectionHandler(event, {
                              categoryId: categoryId,
                              rateplanId: rateplanId
                            })
                          }
                        >
                          <div className="tabcel align_middle pad_left20">
                            <div
                              className="text_end fnt14 color2"
                              title={
                                commonData.otaData[userId]['category'][categoryId]['rateplans'][rateplanId][
                                  'rate_plan_name'
                                ] +
                                ' (' +
                                getOtaRateplanName(categoryId, otaCategoryRateplan, rateplanId)+
                                ' )'
                              }
                            >
                              {getOtaRateplanName(categoryId, otaCategoryRateplan, rateplanId)}
                              <span className="fnt12 color2_2">
                                {' '}
                                ({' '}
                                {
                                  commonData.otaData[userId]['category'][categoryId]['rateplans'][
                                    rateplanId
                                  ]['currency']
                                }{' '}
                                )
                              </span>
                            </div>
                          </div>
                          <div className="tabcel align_middle wdhpx25 tc">
                            {typeof others.rateplanSectionExpand[categoryId] !== 'undefined' &&
                            typeof others.rateplanSectionExpand[categoryId][rateplanId] !== 'undefined' &&
                            others.rateplanSectionExpand[categoryId][rateplanId] === rateplanId ? (
                                <i className="fa fa-minus"></i>
                              ) : (
                                <i className="fa fa-plus"></i>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {dateSectionPopulate(categoryId, rateplanId)}
                  </div>
                </div>
              </div>

              {typeof others.rateplanSectionExpand[categoryId] !== 'undefined' &&
              typeof others.rateplanSectionExpand[categoryId][rateplanId] !== 'undefined' &&
              others.rateplanSectionExpand[categoryId][rateplanId] === rateplanId &&
              typeof commonData.otaData[userId]['category'][categoryId] !== 'undefined' &&
              typeof commonData.otaData[userId]['category'][categoryId]['rateplans'] !== 'undefined' &&
              typeof commonData.otaData[userId]['category'][categoryId]['rateplans'][rateplanId] !==
                'undefined' &&
              typeof commonData.otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates'] !==
                'undefined' ? (
                <div className="cover subchild_data bg2_3 ">
                  <div className="table_seperate table_fixed color2_5">
                    {bindOccupancySection(userId, categoryId, rateplanId)}
                    {/*this.extaBedUIHandler(userId,categoryId,rateplanId)*/}
                  </div>
                </div>
              ) : (
                ''
              )}
            </React.Fragment>
          )
        );
      }
    } else {
      if (
        typeof commonData.otaData[userId]['category'][categoryId] !== 'undefined' &&
        typeof commonData.otaData[userId]['category'][categoryId]['rateplans'] !== 'undefined'
      ) {
        rateplanSection = Object.keys(commonData.otaData[userId]['category'][categoryId]['rateplans']).map(
          rateplanId => (
            <React.Fragment key={categoryId}>
              <div className="cover">
                <div className="table_seperate table_fixed">
                  <div className="table_row">
                    <div className="tabcel align_middle pad_top_bot5 bg1 border_l_1 border_b_1 border_r_1 border_color_1 rvfixed_cell rv_width_1 rv_height_2">
                      <div className="ovr">
                        <div
                          className="table_col table_fixed cursor_p"
                          onClick={event =>
                            props.expandCollapseCategorySectionHandler(event, {
                              categoryId: categoryId,
                              rateplanId: rateplanId
                            })
                          }
                        >
                          <div className="tabcel align_middle pad_left20">
                            <div
                              className="text_end fnt14 color2"
                              title={
                                commonData.otaData[userId]['category'][categoryId]['rateplans'][rateplanId][
                                  'rate_plan_name'
                                ] +
                                ' (' +
                                commonData.otaData[userId]['category'][categoryId][
                                  'channel_rate_plan_name'
                                ] +
                                ' )'
                              }
                            >
                              {commonData.otaData[userId]['category'][categoryId]['channel_rate_plan_name']
                                ? commonData.otaData[userId]['category'][categoryId][
                                  'channel_rate_plan_name'
                                ]
                                : commonData.otaData[userId]['category'][categoryId]['rateplans'][
                                  rateplanId
                                ]['rate_plan_name']}
                              <span className="fnt12 color2_2">
                                {' '}
                                ({' '}
                                {
                                  commonData.otaData[userId]['category'][categoryId]['rateplans'][
                                    rateplanId
                                  ]['currency']
                                }{' '}
                                )
                              </span>
                            </div>
                          </div>
                          <div className="tabcel align_middle wdhpx25 tc">
                            {typeof others.rateplanSectionExpand[categoryId] !== 'undefined' &&
                            typeof others.rateplanSectionExpand[categoryId][rateplanId] !== 'undefined' &&
                            others.rateplanSectionExpand[categoryId][rateplanId] === rateplanId ? (
                                <i className="fa fa-minus"></i>
                              ) : (
                                <i className="fa fa-plus"></i>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {dateSectionPopulate(categoryId, rateplanId)}
                  </div>
                </div>
              </div>

              {typeof others.rateplanSectionExpand[categoryId] !== 'undefined' &&
              typeof others.rateplanSectionExpand[categoryId][rateplanId] !== 'undefined' &&
              others.rateplanSectionExpand[categoryId][rateplanId] === rateplanId &&
              typeof commonData.otaData[userId]['category'][categoryId] !== 'undefined' &&
              typeof commonData.otaData[userId]['category'][categoryId]['rateplans'] !== 'undefined' &&
              typeof commonData.otaData[userId]['category'][categoryId]['rateplans'][rateplanId] !==
                'undefined' &&
              typeof commonData.otaData[userId]['category'][categoryId]['rateplans'][rateplanId]['rates'] !==
                'undefined' ? (
                <div className="cover subchild_data bg2_3 " key={categoryId}>
                  <div className="table_seperate table_fixed color2_5">
                    {bindOccupancySection(userId, categoryId, rateplanId)}
                    {/*this.extaBedUIHandler(userId,categoryId,rateplanId)*/}
                  </div>
                </div>
              ) : (
                ''
              )}
            </React.Fragment>
          )
        );
      }
    }

    return (
      <React.Fragment>
        {typeof others.categorySectionExpand[catId] !== 'undefined' &&
        others.categorySectionExpand[catId] === catId ? (
          <div className="child_colum ovr">{rateplanSection}</div>
        ) : (
          ''
        )}
      </React.Fragment>
    );
  }

  const startSaleCell = (categoryWithMapping, date, identifier, description, localAvailCount) => {
    let catMappingArr = categoryWithMapping.split('_');
    let categoryId = catMappingArr[0];
    return (
      <React.Fragment>
        <div className="d-full-height justify-content-center posrel tc">
          {/*this.commonData.otaData[this.userId]['category'][categoryId]['linked_with']>0?
						<div className="transbg1 linkoverlay"></div> :''*/}
          {description !== '' ? (
            <div className="inline tl align_middle marg_left7">
              <div className="ft align_middle">
                <div className="ovr cursor_p" title={description}>
                  <i className="fa fa-info fnt12 cursor_p color5_2"></i>
                </div>
              </div>
            </div>
          ) : null}
          <div
            className="cover tc"
            onClick={event =>
              props.inventoryCellUIHandler(event, {
                categoryWithMapping: categoryWithMapping,
                categoryId: categoryId,
                date: date,
                identifier: identifier,
                ischecked: '',
                localAvailCount
              })
            }
          >
            <div className="inline width25 round5 bg2_14">
              <div className="inline align_middle pad_top_bot5" title="Available">
                {typeof commonData.otaData[userId] !== 'undefined' &&
                typeof commonData.otaData[userId]['category'] !== 'undefined' &&
                typeof commonData.otaData[userId]['category'][categoryWithMapping] !== 'undefined' &&
                typeof commonData.otaData[userId]['category'][categoryWithMapping]['inventory'] !== 'undefined' &&
                typeof commonData.otaData[userId]['category'][categoryWithMapping]['inventory'][date] !== 'undefined'
                  ? commonData.otaData[userId]['category'][categoryWithMapping]['inventory'][date]['localAvailCount']
                  : 'NA'}
              </div>
            </div>
            {typeof others.inventorySelectedSection[userId] !== 'undefined' &&
            typeof others.inventorySelectedSection[userId][categoryId] !== 'undefined' &&
            typeof others.inventorySelectedSection[userId][categoryId][date] !== 'undefined' &&
            typeof others.inventorySelectedSection[userId][categoryId][date]['isSelected'] !==
              'undefined' &&
            others.inventorySelectedSection[userId][categoryId][date]['isSelected'] === 1 ? (
                <i className="fa fa-check color7 fnt10 color2_8 chkshow marg_right5"></i>
              ) : (
                ''
              )}
          </div>
        </div>
      </React.Fragment>
    );
  }

  const calendarCellUIHandler = (categoryId) => {
    let identifier = 'both';
    let description = '';
    let localAvailCount = 0;
    return Object.keys(dateList).map(date => {
      identifier =
        typeof commonData.otaData[userId] !== 'undefined' &&
        typeof commonData.otaData[userId]['category'] !== 'undefined' &&
        typeof commonData.otaData[userId]['category'][categoryId] !== 'undefined' &&
        typeof commonData.otaData[userId]['category'][categoryId]['inventory'] !== 'undefined' &&
        typeof commonData.otaData[userId]['category'][categoryId]['inventory'][date] !== 'undefined' &&
        typeof commonData.otaData[userId]['category'][categoryId]['inventory'][date]['stopSell'] !== 'undefined' &&
        commonData.otaData[userId]['category'][categoryId]['inventory'][date]['stopSell'] === 1
          ? 'startsale'
          : 'stopsale';

      localAvailCount =
          typeof commonData.otaData[userId] !== 'undefined' &&
          typeof commonData.otaData[userId]['category'] !== 'undefined' &&
          typeof commonData.otaData[userId]['category'][categoryId] !== 'undefined' &&
          typeof commonData.otaData[userId]['category'][categoryId]['inventory'] !== 'undefined' &&
          typeof commonData.otaData[userId]['category'][categoryId]['inventory'][date] !== 'undefined'
            ? commonData.otaData[userId]['category'][categoryId]['inventory'][date]['localAvailCount']
            : 0;

      description =
        typeof commonData.otaData[userId] !== 'undefined' &&
        typeof commonData.otaData[userId]['category'] !== 'undefined' &&
        typeof commonData.otaData[userId]['category'][categoryId] !== 'undefined' &&
        typeof commonData.otaData[userId]['category'][categoryId]['inventory'] !== 'undefined' &&
        typeof commonData.otaData[userId]['category'][categoryId]['inventory'][date] !== 'undefined' &&
        typeof commonData.otaData[userId]['category'][categoryId]['inventory'][date]['description'] !== 'undefined' &&
        commonData.otaData[userId]['category'][categoryId]['inventory'][date]['description'] !== null
          ? commonData.otaData[userId]['category'][categoryId]['inventory'][date]['description']
          : '';

      return (
        <React.Fragment key={date}>
          <div
            className={`tabcel align_middle border_b_1 border_r_1 border_color_1 rv_width_2 rv_height_1
						${identifier === 'startsale' ? 'bg4_3 bg1' : ''}`}
          >
            {startSaleCell(categoryId, date, identifier, description, localAvailCount)}
          </div>
        </React.Fragment>
      );
    });
  }

  const mainCategorySetionUIHandler = () => {
    let otaIds = Object.keys(commonData.otaData);
    let categoryCell = [];
    let categoryData = {};
    //let otaCatRateplan = otaCategoryRateplan;
    for (var i = 0; i < otaIds.length; i++) {
      if (otaIds[0] > 0) {
        //ota category list
        //categoryData = this.commonData.otaData[otaIds[i]]['category'];
        categoryData = otaCategoryRateplan[otaIds[0]];
        // let rateassociatedwithuser = this.props.rateassociatedwithuser[otaIds[0]];
        Object.keys(categoryData).map(channelCategoryId => {
          let catId = categoryData[channelCategoryId]['pms_category_id'];
          //let mappingId = rateassociatedwithuser['category'][catId].mapping_id;
          let mappingId = categoryData[channelCategoryId].mapping_id;
          let categoryId = catId + '_' + mappingId;

          categoryCell.push(
            <React.Fragment key={categoryId}>
              <div key={categoryId} className="wrapper">
                <div className="parent_colum ovr ">
                  <div className="table_seperate table_fixed">
                    <div className="tabcel align_middle pad_top_bot5  border_l_1 border_b_1 border_r_1 border_color_1 rvfixed_cell rv_width_1 rv_height_1 bg1 ">
                      <div className="cover">
                        <div className="table_col table_fixed">
                          <div
                            className="tabcel align_middle wdhpx25 tc"
                            onClick={event =>
                              props.expandCollapseCategorySectionHandler(event, {
                                categoryId: categoryId,
                                rateplanId: 0
                              })
                            }
                          >
                            {typeof others.categorySectionExpand[catId] !== 'undefined' &&
                            others.categorySectionExpand[catId] === catId ? (
                                <i className="fa fa-chevron-down color7"></i>
                              ) : (
                                <i className="fa fa-chevron-right color7"></i>
                              )}
                          </div>
                          <div className="tabcel align_middle pad_left10">
                            <div
                              className="fnt13 bld text_end"
                              title={
                                categoryData[channelCategoryId]['room_category_name'] +
                                ' (' +
                                categoryData[channelCategoryId]['channel_room_type_name'] +
                                ')'
                              }
                            >
                              {categoryData[channelCategoryId]['channel_room_type_name']}
                            </div>
                          </div>
                          <div className="tabcel align_middle wdhpx50 bld" title="Total Inventory">
                            {' '}
                            ( {categoryData[channelCategoryId]['total_rooms']} )
                          </div>
                          <div
                            className="tabcel align_middle wdhpx25 tc"
                            onClick={event =>
                              props.horizontalInventoryUIHandler(event, {
                                userId: userId,
                                categoryId: catId,
                                categoryWithMapping: categoryId
                              })
                            }
                          >
                            {typeof others.horizontalInventoryRowChecked[userId] !==
                              'undefined' &&
                            typeof others.horizontalInventoryRowChecked[userId][catId] !==
                              'undefined' &&
                            typeof others.horizontalInventoryRowChecked[userId][catId][
                              'is_checked'
                            ] !== 'undefined' &&
                            others.horizontalInventoryRowChecked[userId][catId]['is_checked'] ===
                              1 ? (
                                <i className="fa fa-check fnt10 color7"></i>
                              ) : (
                                <i className="fa fa-check fnt10 color2_8"></i>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {calendarCellUIHandler(categoryId)}
                  </div>
                </div>
                  { tty(categoryData,channelCategoryId, otaIds,catId)

                  }
              </div>
            </React.Fragment>
          );
        });
      } else {
        //system category list
        categoryData = commonData.otaData[otaIds[i]]['category'];
        Object.keys(categoryData).map(categoryId => {
          let catMapArr = categoryId.split('_');
          let catId = catMapArr[0];
          categoryCell.push(
            <React.Fragment key={catMapArr}>
              <div className="wrapper">
                <div className="parent_colum ovr ">
                  <div className="table_seperate table_fixed">
                    <div className="tabcel align_middle pad_top_bot5  border_l_1 border_b_1 border_r_1 border_color_1 rvfixed_cell rv_width_1 rv_height_1 bg1 ">
                      <div className="cover">
                        <div className="table_col table_fixed">
                          <div
                            className="tabcel align_middle wdhpx25 tc"
                            onClick={event =>
                              props.expandCollapseCategorySectionHandler(event, {
                                categoryId: categoryId,
                                rateplanId: 0
                              })
                            }
                          >
                            {typeof others.categorySectionExpand[catId] !== 'undefined' &&
                            others.categorySectionExpand[catId] === catId ? (
                                <i className="fa fa-chevron-down color7"></i>
                              ) : (
                                <i className="fa fa-chevron-right color7"></i>
                              )}
                          </div>
                          <div className="tabcel align_middle pad_left10">
                            <div
                              className="fnt13 bld text_end"
                              title={
                                categoryData[categoryId]['room_category_name'] +
                                ' (' +
                                categoryData[categoryId]['channel_room_type_name'] +
                                ')'
                              }
                            >
                              {categoryData[categoryId]['channel_room_type_name']
                                ? categoryData[categoryId]['channel_room_type_name']
                                : categoryData[categoryId]['room_category_name']}
                            </div>
                          </div>
                          <div className="tabcel align_middle wdhpx50 bld" title="Total Inventory">
                            {' '}
                            ( {categoryData[categoryId]['total_rooms']} )
                          </div>
                          <div
                            className="tabcel align_middle wdhpx25 tc"
                            onClick={event =>
                              props.horizontalInventoryUIHandler(event, {
                                userId: userId,
                                categoryId: catId,
                                categoryWithMapping: categoryId
                              })
                            }
                          >
                            {typeof others.horizontalInventoryRowChecked[userId] !==
                              'undefined' &&
                            typeof others.horizontalInventoryRowChecked[userId][catId] !==
                              'undefined' &&
                            typeof others.horizontalInventoryRowChecked[userId][catId][
                              'is_checked'
                            ] !== 'undefined' &&
                            others.horizontalInventoryRowChecked[userId][catId]['is_checked'] ===
                              1 ? (
                                <i className="fa fa-check fnt10 color7"></i>
                              ) : (
                                <i className="fa fa-check fnt10 color2_8"></i>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {calendarCellUIHandler(categoryId)}
                  </div>
                </div>
                {Object.keys(others.categorySectionExpand).length > 0
                  ? ratePlanUIpaint(categoryId, otaIds[i])
                  : ''}
              </div>
            </React.Fragment>
          );
        });
      }
    }
    return categoryCell;
  }


  const tty = (categoryData,channelCategoryId, otaIds,catId) => {
    return(
      <div>
        {Object.keys(categoryData[channelCategoryId]['rateplans']).map(data => {
          let categoryId_ = catId + '_' + categoryData[channelCategoryId]['rateplans'][data].rate_plan_mapping_id;
          return (
            <div key={categoryId_}>
              {ratePlanUIpaint(categoryId_, otaIds)}
            </div>
          );
        })
      }
      </div>
    );
  }
  return (
    <div className="inventry_wrap bg1">
      <div className="inventry_inner">
        <div className="wrapper">
          {Object.keys(commonData.otaData).length > 0 ? mainCategorySetionUIHandler() : ''}
        </div>
      </div>
    </div>
  );
};

export default RateInventory;
